import React, { useState } from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import "../../Assets/css/footer.css";
import { Link, NavLink } from "react-router-dom";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material/";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Address_details,
  Email_details,
  Email_detailsSecond,
  ImageUrl,
  Theme,
  client_name,
  contact_number,
  helmet_url,
  media_details,
} from "../../Helpers/request";
import { isDesktop } from "react-device-detect";
import EdiLogo from "../Front/themes/showcase/assets/imges/edi-logo-desktop1.png";

// import FooterVenice from "../Front/themes/venice/Footer/FooterVenice";

const Footer = () => {
  const [expanded, setExpanded] = React.useState(false);
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div>
 
        <div className={`${Theme}_footer`}>
          <div className="rcs_footer" id="rcs_footer">
            <Container
              fluid
              className="showcase-container rcs_custom_home_container"
            >
              <div className="d-none d-lg-block">
                <Row className="justify-content-between">
                  <Col xs={12} sm={6} md={12} lg={4}>
                    <div className="rcs_footer_content_one ">
                      <div className="logo">
                        <NavLink to="/">
                          <Image
                            height="60"
                            style={{ marginLeft: "-6px" }}
                            src={EdiLogo}
                            alt={client_name.c_name}
                          />
                        </NavLink>
                      </div>
                      <p>
                        {" "}
                        {client_name.c_name} in the field of the Diamond
                        industry with an experience of over 25 years. We
                        revolutionized the industry with a disruptive online
                        business model.{" "}
                        <NavLink to="/our-story">Read More</NavLink>
                      </p>
                    </div>
                    <div className="rcs_footer_content_one_social_icn">
                      <ul>
                        {/* {
                      media_details.map((media, id) =>
                        <li key={id}>
                          <div className="rcs_footer_content_one_social_icn_div">
                            <a href={media.account_link} target="_blank"  >{media.account_icon}</a>
                          </div>
                        </li>
                      )} */}
                        {/* <li>
                      <div className="rcs_footer_content_one_social_icn_div">
                        <a href="https://twitter.com/belgiumwebnet" target="_blank" >   <RiTwitterFill /> </a>
                      </div>
                    </li>
                    <li>
                      <div className="rcs_footer_content_one_social_icn_div">
                        <a href="https://www.instagram.com/belgium_webnet/" target="_blank" >    <RiInstagramLine /> </a>
                      </div>
                    </li>
                    <li>
                      <div className="rcs_footer_content_one_social_icn_div">
                        <a href="https://www.linkedin.com/company/belgium-webnet/" target="_blank" >  <RiLinkedinBoxFill /> </a>
                      </div>
                    </li> */}
                      </ul>
                    </div>
                  </Col>
                  <Col xs={12} sm={6} md={6} lg={2}>
                    <div className="rcs_footer_content rcs_info">
                      <h2 className="mb-3">Information</h2>
                      <ul className="rcs_footer_list">
                        <li>
                          <NavLink to="/our-story">Our Story</NavLink>
                        </li>
                        <li>
                          <NavLink to="/contact">Contact Us</NavLink>
                        </li>
                        {/* <li><NavLink to="/blog">Blog</NavLink></li> */}
                        {/* <li><NavLink to="/education">Education</NavLink></li> */}
                        <li>
                          <NavLink to="/privacy-policy">Privacy Policy</NavLink>
                        </li>
                        <li>
                          <NavLink to="/terms-and-conditions">
                            Terms & Condition
                          </NavLink>
                        </li>
                        <li>
                          <NavLink to="/make-an-appointment">
                            Virtual Appointment
                          </NavLink>
                        </li>
                      </ul>
                    </div>
                  </Col>
                  <Col xs={12} sm={6} md={6} lg={2}>
                    <div className="rcs_footer_content rcs_info">
                      <h2 className="mb-3">Collection</h2>
                      <ul className="rcs_footer_list">
                        <li>
                          <NavLink to="/jewelry/fashion-rings">Rings</NavLink>
                        </li>
                        <li>
                          <NavLink to="/jewelry/necklaces">Necklaces</NavLink>
                        </li>
                        <li>
                          <NavLink to="/jewelry/earrings">Earrings</NavLink>
                        </li>
                        <li>
                          <NavLink to="/jewelry/pendants">Pendants</NavLink>
                        </li>
                        <li>
                          <NavLink to="/jewelry/bracelets">Bracelets</NavLink>
                        </li>
                      </ul>
                    </div>
                  </Col>
                  <Col
                    xs={12}
                    sm={6}
                    md={6}
                    lg={2}
                    className="d-flex justify-content-end"
                  >
                    <div className="rcs_footer_content">
                      <h2 className="mb-3">Get in Touch</h2>
                      <ul className="rcs_footer_list">
                        {/* <p className='mt-0'>Address: </p> */}
                        <li
                          onClick={() => {
                            window.open(Address_details.link, "_blank");
                          }}
                        >
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M2.91699 8.59797C2.91699 4.76475 6.12023 1.6665 9.99486 1.6665C13.8804 1.6665 17.0837 4.76475 17.0837 8.59797C17.0837 10.5296 16.3812 12.3229 15.2249 13.8428C13.9493 15.5194 12.3771 16.9802 10.6074 18.1269C10.2024 18.3919 9.83689 18.4118 9.39237 18.1269C7.61261 16.9802 6.0404 15.5194 4.77574 13.8428C3.61865 12.3229 2.91699 10.5296 2.91699 8.59797ZM7.66218 8.8138C7.66218 10.0979 8.71004 11.1079 9.99486 11.1079C11.2805 11.1079 12.3385 10.0979 12.3385 8.8138C12.3385 7.53967 11.2805 6.48053 9.99486 6.48053C8.71004 6.48053 7.66218 7.53967 7.66218 8.8138Z"
                              fill="currentColor"
                            />
                          </svg>
                          {Address_details.textLine1}
                          <br />
                          {Address_details.textLine2}
                        </li>

                        <li
                          onClick={(e) => {
                            window.location.href = contact_number.link;
                          }}
                        >
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M9.60946 10.3933C12.9337 13.7166 13.6878 9.87194 15.8044 11.987C17.8449 14.027 19.0177 14.4357 16.4324 17.0203C16.1085 17.2805 14.051 20.4116 6.82018 13.1827C-0.411557 5.95301 2.71766 3.89338 2.97798 3.56963C5.56956 0.977879 5.97123 2.15749 8.01175 4.19745C10.1283 6.31342 6.28522 7.07002 9.60946 10.3933Z"
                              fill="currentColor"
                            />
                          </svg>

                          {contact_number.text}
                        </li>
                        <li
                          
                        >
                          <a href={Email_details.link}   style={{ cursor: "pointer", textDecoration: "none", color: "inherit" }} >
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M14.1162 2.5C15.2337 2.5 16.3087 2.94167 17.0995 3.73417C17.8912 4.525 18.3337 5.59167 18.3337 6.70833V13.2917C18.3337 15.6167 16.442 17.5 14.1162 17.5H5.88366C3.55783 17.5 1.66699 15.6167 1.66699 13.2917V6.70833C1.66699 4.38333 3.54949 2.5 5.88366 2.5H14.1162ZM15.442 7.95L15.5087 7.88333C15.7078 7.64167 15.7078 7.29167 15.4995 7.05C15.3837 6.92583 15.2245 6.85 15.0587 6.83333C14.8837 6.82417 14.717 6.88333 14.5912 7L10.8337 10C10.3503 10.4008 9.65783 10.4008 9.16699 10L5.41699 7C5.15783 6.80833 4.79949 6.83333 4.58366 7.05833C4.35866 7.28333 4.33366 7.64167 4.52449 7.89167L4.63366 8L8.42533 10.9583C8.89199 11.325 9.45783 11.525 10.0503 11.525C10.6412 11.525 11.217 11.325 11.6828 10.9583L15.442 7.95Z"
                              fill="currentColor"
                            />
                          </svg>
                          {Email_details.text}
                          </a>
                        </li>
                        {/* <li
                          onClick={(e) => {
                            window.location.href = Email_detailsSecond.link;
                          }}
                        >
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M14.1162 2.5C15.2337 2.5 16.3087 2.94167 17.0995 3.73417C17.8912 4.525 18.3337 5.59167 18.3337 6.70833V13.2917C18.3337 15.6167 16.442 17.5 14.1162 17.5H5.88366C3.55783 17.5 1.66699 15.6167 1.66699 13.2917V6.70833C1.66699 4.38333 3.54949 2.5 5.88366 2.5H14.1162ZM15.442 7.95L15.5087 7.88333C15.7078 7.64167 15.7078 7.29167 15.4995 7.05C15.3837 6.92583 15.2245 6.85 15.0587 6.83333C14.8837 6.82417 14.717 6.88333 14.5912 7L10.8337 10C10.3503 10.4008 9.65783 10.4008 9.16699 10L5.41699 7C5.15783 6.80833 4.79949 6.83333 4.58366 7.05833C4.35866 7.28333 4.33366 7.64167 4.52449 7.89167L4.63366 8L8.42533 10.9583C8.89199 11.325 9.45783 11.525 10.0503 11.525C10.6412 11.525 11.217 11.325 11.6828 10.9583L15.442 7.95Z"
                              fill="currentColor"
                            />
                          </svg>
                          {Email_detailsSecond.text}
                        </li> */}
                      </ul>
                    </div>
                  </Col>

                  {/* <Col xs={12} sm={6} md={6} lg={2}>
                <div className='rcs_footer_content'>
                  <h2 className='mb-3'>Help</h2>
                  <ul className='rcs_footer_list'>
                    <li><NavLink to="/faq">FAQ’s</NavLink></li>
                    <li><NavLink to="/contact">Contact Us</NavLink></li>
                  </ul>
                </div>
              </Col> */}
                </Row>
              </div>
            </Container>
          </div>
          <section className="d-lg-none d-md-block rcs_mobile_footer_section">
            <Container>
              <div className="gs_footer_content d-lg-none d-md-block  ">
                <Row className="m-0 w-100">
                  <Col xs={12}>
                    <div className="rcs_footer_content_one ">
                      <div className="logo">
                        <NavLink to="/">
                          <Image
                            height="52"
                            src={EdiLogo}
                            alt={client_name.c_name}
                          />
                        </NavLink>
                      </div>
                      <p>
                        {" "}
                        {client_name.c_name} in the field of the Diamond
                        industry with an experience of over 25 years. We
                        revolutionized the industry with a disruptive online
                        business model. <br />
                        <Link to="/our-story">Read More</Link>
                      </p>
                    </div>
                    {/* <div className="rcs_footer_content_one_social_icn">
                  <ul>
                    {
                      media_details.map((media) =>
                        <li>
                          <div className="rcs_footer_content_one_social_icn_div">
                            <a href={media.account_link} target='_blank' rel="noreferrer">{media.account_icon}</a>
                          </div>
                        </li>
                      )}
                  </ul>
                </div> */}
                  </Col>
                  <Accordion
                    expanded={expanded === "panel2"}
                    onChange={handleChange("panel2")}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel2bh-content"
                      id="panel2bh-header"
                      className="rcs_footer_t_color_white"
                    >
                      <span className="footer-mobile-heading">Information</span>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography>
                        <div className="block-footer3">
                          <ul className="rcs_footer_list contact-foter2">
                            <li>
                              <NavLink to="/our-story">Our Story</NavLink>
                            </li>
                            <li>
                              <NavLink to="/contact">Contact Us</NavLink>
                            </li>
                            {/* <li><NavLink to="/blog">Blog</NavLink></li> */}
                            {/* <li><NavLink to="/education">Education</NavLink></li> */}
                            <li>
                              <NavLink to="/privacy-policy">
                                Privacy Policy
                              </NavLink>
                            </li>
                            <li>
                              <NavLink to="/terms-and-conditions">
                                Terms & Condition
                              </NavLink>
                            </li>
                            <li>
                              <NavLink to="/make-an-appointment">
                                Virtual Appointment
                              </NavLink>
                            </li>
                          </ul>
                        </div>
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion
                    expanded={expanded === "panel3"}
                    onChange={handleChange("panel3")}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel3bh-content"
                      id="panel3bh-header"
                      className="rcs_footer_t_color_white"
                    >
                      <span className="footer-mobile-heading">Collection</span>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography>
                        <div className="block-footer3">
                          <ul className="rcs_footer_list contact-foter2">
                            <li>
                              <NavLink to="/jewelry/fashion-rings">
                                Rings
                              </NavLink>
                            </li>
                            <li>
                              <NavLink to="/jewelry/necklaces">
                                Necklaces
                              </NavLink>
                            </li>
                            <li>
                              <NavLink to="/jewelry/earrings">Earrings</NavLink>
                            </li>
                            <li>
                              <NavLink to="/jewelry/pendants">Pendants</NavLink>
                            </li>
                            <li>
                              <NavLink to="/jewelry/bracelets">
                                Bracelets
                              </NavLink>
                            </li>
                          </ul>
                        </div>
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion
                    expanded={expanded === "panel4"}
                    onChange={handleChange("panel4")}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel4bh-content"
                      id="panel4bh-header"
                      className="rcs_footer_t_color_white"
                    >
                      <span className="footer-mobile-heading">
                        Get in Touch
                      </span>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography>
                        <div className="block-footer3">
                          <ul className="list-none contact-foter2">
                            {/* <p className='mt-0'>Address: </p> */}
                            <li
                              onClick={() => {
                                window.open(Address_details.link, "_blank");
                              }}
                            >
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M2.91699 8.59797C2.91699 4.76475 6.12023 1.6665 9.99486 1.6665C13.8804 1.6665 17.0837 4.76475 17.0837 8.59797C17.0837 10.5296 16.3812 12.3229 15.2249 13.8428C13.9493 15.5194 12.3771 16.9802 10.6074 18.1269C10.2024 18.3919 9.83689 18.4118 9.39237 18.1269C7.61261 16.9802 6.0404 15.5194 4.77574 13.8428C3.61865 12.3229 2.91699 10.5296 2.91699 8.59797ZM7.66218 8.8138C7.66218 10.0979 8.71004 11.1079 9.99486 11.1079C11.2805 11.1079 12.3385 10.0979 12.3385 8.8138C12.3385 7.53967 11.2805 6.48053 9.99486 6.48053C8.71004 6.48053 7.66218 7.53967 7.66218 8.8138Z"
                                  fill="currentColor"
                                />
                              </svg>
                              {Address_details.textLine1}
                              <br />
                              {Address_details.textLine2}
                            </li>

                            <li
                              onClick={(e) => {
                                window.location.href = contact_number.link;
                              }}
                            >
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M9.60946 10.3933C12.9337 13.7166 13.6878 9.87194 15.8044 11.987C17.8449 14.027 19.0177 14.4357 16.4324 17.0203C16.1085 17.2805 14.051 20.4116 6.82018 13.1827C-0.411557 5.95301 2.71766 3.89338 2.97798 3.56963C5.56956 0.977879 5.97123 2.15749 8.01175 4.19745C10.1283 6.31342 6.28522 7.07002 9.60946 10.3933Z"
                                  fill="currentColor"
                                />
                              </svg>

                              {contact_number.text}
                            </li>
                            <li
                              className="pb-1"
                              onClick={(e) => {
                                window.location.href = Email_details.link;
                              }}
                            >
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M14.1162 2.5C15.2337 2.5 16.3087 2.94167 17.0995 3.73417C17.8912 4.525 18.3337 5.59167 18.3337 6.70833V13.2917C18.3337 15.6167 16.442 17.5 14.1162 17.5H5.88366C3.55783 17.5 1.66699 15.6167 1.66699 13.2917V6.70833C1.66699 4.38333 3.54949 2.5 5.88366 2.5H14.1162ZM15.442 7.95L15.5087 7.88333C15.7078 7.64167 15.7078 7.29167 15.4995 7.05C15.3837 6.92583 15.2245 6.85 15.0587 6.83333C14.8837 6.82417 14.717 6.88333 14.5912 7L10.8337 10C10.3503 10.4008 9.65783 10.4008 9.16699 10L5.41699 7C5.15783 6.80833 4.79949 6.83333 4.58366 7.05833C4.35866 7.28333 4.33366 7.64167 4.52449 7.89167L4.63366 8L8.42533 10.9583C8.89199 11.325 9.45783 11.525 10.0503 11.525C10.6412 11.525 11.217 11.325 11.6828 10.9583L15.442 7.95Z"
                                  fill="currentColor"
                                />
                              </svg>
                              {Email_details.text}
                            </li>
                            {/* <li
                              onClick={(e) => {
                                window.location.href = Email_detailsSecond.link;
                              }}
                            >
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M14.1162 2.5C15.2337 2.5 16.3087 2.94167 17.0995 3.73417C17.8912 4.525 18.3337 5.59167 18.3337 6.70833V13.2917C18.3337 15.6167 16.442 17.5 14.1162 17.5H5.88366C3.55783 17.5 1.66699 15.6167 1.66699 13.2917V6.70833C1.66699 4.38333 3.54949 2.5 5.88366 2.5H14.1162ZM15.442 7.95L15.5087 7.88333C15.7078 7.64167 15.7078 7.29167 15.4995 7.05C15.3837 6.92583 15.2245 6.85 15.0587 6.83333C14.8837 6.82417 14.717 6.88333 14.5912 7L10.8337 10C10.3503 10.4008 9.65783 10.4008 9.16699 10L5.41699 7C5.15783 6.80833 4.79949 6.83333 4.58366 7.05833C4.35866 7.28333 4.33366 7.64167 4.52449 7.89167L4.63366 8L8.42533 10.9583C8.89199 11.325 9.45783 11.525 10.0503 11.525C10.6412 11.525 11.217 11.325 11.6828 10.9583L15.442 7.95Z"
                                  fill="currentColor"
                                />
                              </svg>
                              {Email_detailsSecond.text}
                            </li> */}
                          </ul>
                        </div>
                      </Typography>
                    </AccordionDetails>
                  </Accordion>

                  {/* <Accordion expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel4bh-content"
                  id="panel4bh-header"
                  className="rcs_footer_t_color_white"
                >
                  <span className='footer-mobile-heading'>Help</span>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    <div className="block-footer3">
                      <ul className='rcs_footer_list contact-foter2'>
                        <li><NavLink to="/faq">FAQ’s</NavLink></li>
                        <li><NavLink to="/contact">Contact Us</NavLink></li>
                      </ul>
                    </div>
                  </Typography>
                </AccordionDetails>
              </Accordion> */}
                </Row>
              </div>
            </Container>
          </section>

          {isDesktop ? (
            <div className="rcs_footer_bottom" id="rcs_footer_bottom">
              <Container className="showcase-container rcs_custom_home_container">
                <Row className="w-100 m-auto justify-content-center align-items-center">
                  <Col lg={8} md={12} className="p-0">
                    <div className="rcs_footer_bottom_content">
                      <p>
                        {" "}
                        Copyright © {new Date().getFullYear()}{" "}
                        {client_name.c_name} All Rights Reserved. | Designed &
                        Developed by <a href="https://belgiumwebnet.com/" target="_blank"> Belgium Webnet</a>
                      </p>
                    </div>
                  </Col>
                  <Col lg={4} md={12}>
                    <ul className="d-flex justify-content-end align-items-center">
                      {media_details.map((media, id) => (
                        <li key={id} className="mr-2">
                          <div className="rcs_footer_content_one_social_icn_div">
                            <a href={media.account_link} target="_blank" aria-label={media.account_alt} rel="noreferrer">
                              {media.account_icon}
                              <span className="d-none">
                                {media.account_alt}
                              </span>
                            </a>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </Col>
                  {/* <Col lg={4} md={12}>
                    <div className="rcs_footer_logo_main">
                      <ul>
                        <li>
                          <div className="rcs_footer_logo_img_div">
                            <a
                              href="https://www.rapnet.com/"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <Image
                                src={`${ImageUrl}home/rapnet.webp`}
                                alt="Rapnet"
                              />
                            </a>
                          </div>
                        </li>
                        <li>
                          <div className="rcs_footer_logo_img_div">
                            <a
                              href="https://www.overnightmountings.com/"
                              target="_blank"
                              rel="noreferrer"
                            >
                              {" "}
                              <Image
                                src={`${ImageUrl}home/overnight.webp`}
                                alt="Overnight"
                              />
                            </a>
                          </div>
                        </li>
                        <li>
                          <div className="rcs_footer_logo_img_div">
                            <a
                              href="https://www.vdbapp.com/"
                              target="_blank"
                              rel="noreferrer"
                            >
                              {" "}
                              <Image
                                src={`${ImageUrl}home/vdb.webp`}
                                alt="VDB"
                              />
                            </a>
                          </div>
                        </li>
                        <li>
                          <div className="rcs_footer_logo_img_div">
                            <a
                              href="https://www.ivouch.com/"
                              target="_blank"
                              rel="noreferrer"
                            >
                              {" "}
                              <Image
                                src={`${ImageUrl}home/ivouch.webp`}
                                alt="IVach"
                              />
                            </a>
                          </div>
                        </li>
                        <li>
                          <div className="rcs_footer_logo_img_div">
                            <a
                              href="https://www.yelp.com/"
                              target="_blank"
                              rel="noreferrer"
                            >
                              {" "}
                              <Image
                                src={`${ImageUrl}home/yelp.webp`}
                                alt="Yelp"
                              />
                            </a>
                          </div>
                        </li>
                        <li>
                          <div className="rcs_footer_logo_img_div">
                            <a
                              href="https://www.google.com/"
                              target="_blank"
                              rel="noreferrer"
                            >
                              {" "}
                              <Image
                                src={`${ImageUrl}home/google.webp`}
                                alt="Google"
                              />
                            </a>
                          </div>
                        </li>
                        <li>
                          <div className="rcs_footer_logo_img_div">
                            <a
                              href="https://www.paypal.com/in/webapps/mpp/home?gclsrc=aw.ds&gclid=EAIaIQobChMI7sKht7nn5gIVGAkrCh2VHgXsEAAYASAAEgJAX_D_BwE&gclsrc=aw.ds"
                              target="_blank"
                              rel="noreferrer"
                            >
                              {" "}
                              <Image
                                src={`${ImageUrl}home/paypal.webp`}
                                alt="Paypal"
                              />
                            </a>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </Col> */}
                </Row>
              </Container>
            </div>
          ) : (
            // Mobile footer
            <div className="rcs_footer_bottom" id="rcs_footer_bottom">
              <div className="showcase-container rcs_custom_home_container">
                <Row className="w-100 m-auto justify-content-center">
                  <Col lg={4} md={12}>
                    <ul className="d-flex justify-content-center align-items-center">
                      {media_details.map((media, id) => (
                        <li key={id} className="mr-2">
                          <div className="rcs_footer_content_one_social_icn_div">
                            <a href={media.account_link} target="_blank" rel="noreferrer" aria-label={media.account_alt}>
                              {media.account_icon}{" "}
                              <span className="d-none">
                                {media.account_alt}
                              </span>
                            </a>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </Col>
                  {/* <Col lg={4} md={12}>
                    <div className="rcs_footer_logo_main">
                      <ul>
                        <li>
                          <div className="rcs_footer_logo_img_div">
                            <a
                              href="https://www.rapnet.com/"
                              target="_blank"
                              rel="noreferrer"
                            >
                              {" "}
                              <Image
                                src={`${ImageUrl}home/rapnet.webp`}
                                alt="Rapnet"
                              />
                            </a>
                          </div>
                        </li>
                        <li>
                          <div className="rcs_footer_logo_img_div">
                            <a
                              href="https://www.overnightmountings.com/"
                              target="_blank"
                              rel="noreferrer"
                            >
                              {" "}
                              <Image
                                src={`${ImageUrl}home/overnight.webp`}
                                alt="Overnight"
                              />
                            </a>
                          </div>
                        </li>
                        <li>
                          <div className="rcs_footer_logo_img_div">
                            <a
                              href="https://www.vdbapp.com/"
                              target="_blank"
                              rel="noreferrer"
                            >
                              {" "}
                              <Image
                                src={`${ImageUrl}home/vdb.webp`}
                                alt="VDB"
                              />
                            </a>
                          </div>
                        </li>
                        <li>
                          <div className="rcs_footer_logo_img_div">
                            <a
                              href="https://www.ivouch.com/"
                              target="_blank"
                              rel="noreferrer"
                            >
                              {" "}
                              <Image
                                src={`${ImageUrl}home/ivouch.webp`}
                                alt="IVach"
                              />
                            </a>
                          </div>
                        </li>
                        <li>
                          <div className="rcs_footer_logo_img_div">
                            <a
                              href="https://www.yelp.com/"
                              target="_blank"
                              rel="noreferrer"
                            >
                              {" "}
                              <Image
                                src={`${ImageUrl}home/yelp.webp`}
                                alt="Yelp"
                              />
                            </a>
                          </div>
                        </li>
                        <li>
                          <div className="rcs_footer_logo_img_div">
                            <a
                              href="https://www.google.com/"
                              target="_blank"
                              rel="noreferrer"
                            >
                              {" "}
                              <Image
                                src={`${ImageUrl}home/google.webp`}
                                alt="Google"
                              />
                            </a>
                          </div>
                        </li>
                        <li>
                          <div className="rcs_footer_logo_img_div">
                            <a
                              href="https://www.paypal.com/in/webapps/mpp/home?gclsrc=aw.ds&gclid=EAIaIQobChMI7sKht7nn5gIVGAkrCh2VHgXsEAAYASAAEgJAX_D_BwE&gclsrc=aw.ds"
                              target="_blank"
                              rel="noreferrer"
                            >
                              {" "}
                              <Image
                                src={`${ImageUrl}home/paypal.webp`}
                                alt="Paypal"
                              />
                            </a>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </Col> */}
                  <Col lg={4} md={12} className="p-0">
                    <div className="rcs_footer_bottom_content">
                      <p>
                        {" "}
                        Copyright © {new Date().getFullYear()}.{" "}
                        {client_name.c_name} All Rights Reserved. | Designed and
                        Developed by <a href="https://belgiumwebnet.com/" target="_blank"> Belgium Webnet</a>
                      </p>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          )}
          <Container>
            <div className="seo_urlsss">
              <ul>
                <li>
                  <a href={`${helmet_url}/jewelry/bracelets`}>
                    https://showcase.demobw.com/jewelry/bracelets
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/jewelry/fashion-rings`}>
                    https://showcase.demobw.com/jewelry/fashion-rings
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/jewelry/necklaces`}>
                    https://showcase.demobw.com/jewelry/necklaces
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/blog`}>
                    https://showcase.demobw.com/blog
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/education`}>
                    https://showcase.demobw.com/education
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/jewelry/earrings`}>
                    https://showcase.demobw.com/jewelry/earrings
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/jewelry/pendants`}>
                    https://showcase.demobw.com/jewelry/pendants
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/`}>https://showcase.demobw.com/</a>
                </li>
                <li>
                  <a href={`${helmet_url}/contact`}>
                    https://showcase.demobw.com/contact
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/faq`}>
                    https://showcase.demobw.com/faq
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/our-story`}>
                    https://showcase.demobw.com/our-story
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/privacy-policy`}>
                    https://showcase.demobw.com/privacy-policy
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/terms-and-conditions`}>
                    https://showcase.demobw.com/terms-and-conditions
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds`}>
                    https://showcase.demobw.com/diamonds
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/ringsettings/diamonds`}>
                    https://showcase.demobw.com/ringsettings/diamonds
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstones`}>
                    https://showcase.demobw.com/gemstones
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds/lab`}>
                    https://showcase.demobw.com/diamonds/lab
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/education/engagement-ring-education`}>
                    https://showcase.demobw.com/education/engagement-ring-education
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/education/fine-jewelry-education`}>
                    https://showcase.demobw.com/education/fine-jewelry-education
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/education/gemstone-education`}>
                    https://showcase.demobw.com/education/gemstone-education
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/education/loose-diamonds-education`}>
                    https://showcase.demobw.com/education/loose-diamonds-education
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/education/wedding-ring-education`}>
                    https://showcase.demobw.com/education/wedding-ring-education
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/blog-details/december-birthstones-turquoise-tanzanite-and-zircon1`}
                  >
                    https://showcase.demobw.com/blog-details/december-birthstones-turquoise-tanzanite-and-zircon1
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/blog-details/december-birthstones-turquoise-tanzanite-and-zircon2`}
                  >
                    https://showcase.demobw.com/blog-details/december-birthstones-turquoise-tanzanite-and-zircon2
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/blog-details/december-birthstones-turquoise-tanzanite-and-zircon3`}
                  >
                    https://showcase.demobw.com/blog-details/december-birthstones-turquoise-tanzanite-and-zircon3
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/blog-details/december-birthstones-turquoise-tanzanite-and-zircon5`}
                  >
                    https://showcase.demobw.com/blog-details/december-birthstones-turquoise-tanzanite-and-zircon5
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/blog-details/december-birthstones:-turquoise,-tanzanite,-and-zircon`}
                  >
                    https://showcase.demobw.com/blog-details/december-birthstones:-turquoise,-tanzanite,-and-zircon
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/blog-details/the-most-amazing-halloween-themed-wedding`}
                  >
                    https://showcase.demobw.com/blog-details/the-most-amazing-halloween-themed-wedding
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/fancy-color-diamond`}>
                    https://showcase.demobw.com/fancy-color-diamond
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/13875`}>
                    https://showcase.demobw.com/diamonds-details/13875
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/13993AA`}>
                    https://showcase.demobw.com/diamonds-details/13993AA
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/14025A`}>
                    https://showcase.demobw.com/diamonds-details/14025A
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/14037AA`}>
                    https://showcase.demobw.com/diamonds-details/14037AA
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/14226`}>
                    https://showcase.demobw.com/diamonds-details/14226
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/14797`}>
                    https://showcase.demobw.com/diamonds-details/14797
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/15002A`}>
                    https://showcase.demobw.com/diamonds-details/15002A
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/15422`}>
                    https://showcase.demobw.com/diamonds-details/15422
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/15456`}>
                    https://showcase.demobw.com/diamonds-details/15456
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstone-details/0157-194863`}>
                    https://showcase.demobw.com/gemstone-details/0157-194863
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstone-details/0157-225746`}>
                    https://showcase.demobw.com/gemstone-details/0157-225746
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstone-details/0157-271829`}>
                    https://showcase.demobw.com/gemstone-details/0157-271829
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstone-details/0157-383030`}>
                    https://showcase.demobw.com/gemstone-details/0157-383030
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstone-details/0157-411244`}>
                    https://showcase.demobw.com/gemstone-details/0157-411244
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstone-details/0157-428372`}>
                    https://showcase.demobw.com/gemstone-details/0157-428372
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstone-details/0157-461540`}>
                    https://showcase.demobw.com/gemstone-details/0157-461540
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstone-details/0157-471837`}>
                    https://showcase.demobw.com/gemstone-details/0157-471837
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstone-details/0157-708913`}>
                    https://showcase.demobw.com/gemstone-details/0157-708913
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstone-details/0157-887513`}>
                    https://showcase.demobw.com/gemstone-details/0157-887513
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstone-details/0157-907190`}>
                    https://showcase.demobw.com/gemstone-details/0157-907190
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstone-details/0157-943809`}>
                    https://showcase.demobw.com/gemstone-details/0157-943809
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/400004`}>
                    https://showcase.demobw.com/diamonds-details/400004
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/400020`}>
                    https://showcase.demobw.com/diamonds-details/400020
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/400021`}>
                    https://showcase.demobw.com/diamonds-details/400021
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/400026`}>
                    https://showcase.demobw.com/diamonds-details/400026
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/400049`}>
                    https://showcase.demobw.com/diamonds-details/400049
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/400052`}>
                    https://showcase.demobw.com/diamonds-details/400052
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/400073`}>
                    https://showcase.demobw.com/diamonds-details/400073
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/400081`}>
                    https://showcase.demobw.com/diamonds-details/400081
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/400115`}>
                    https://showcase.demobw.com/diamonds-details/400115
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/400209`}>
                    https://showcase.demobw.com/diamonds-details/400209
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/fancy-color-diamond-detail/1009-1376`}
                  >
                    https://showcase.demobw.com/fancy-color-diamond-detail/1009-1376
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/"https://showcase.demobw.com`}>
                    https://showcase.demobw.com
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/2021-gift-guide`}>
                    https://showcase.demobw.com/2021-gift-guide
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/account/myaccount`}>
                    https://showcase.demobw.com/account/myaccount
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/ada-compliance`}>
                    https://showcase.demobw.com/ada-compliance
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/careers`}>
                    https://showcase.demobw.com/careers
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/cart`}>
                    https://showcase.demobw.com/cart
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/charities`}>
                    https://showcase.demobw.com/charities
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/checkout-shipping`}>
                    https://showcase.demobw.com/checkout-shipping
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/complete-diamond-ring`}>
                    https://showcase.demobw.com/complete-diamond-ring
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/complete-fancycolor-ring`}>
                    https://showcase.demobw.com/complete-fancycolor-ring
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/complete-gemstone-ring`}>
                    https://showcase.demobw.com/complete-gemstone-ring
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/custom-design`}>
                    https://showcase.demobw.com/custom-design
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/15551A`}>
                    https://showcase.demobw.com/diamonds-details/15551A
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/15708`}>
                    https://showcase.demobw.com/diamonds-details/15708
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/16472`}>
                    https://showcase.demobw.com/diamonds-details/16472
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/16511`}>
                    https://showcase.demobw.com/diamonds-details/16511
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/16545`}>
                    https://showcase.demobw.com/diamonds-details/16545
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/16632`}>
                    https://showcase.demobw.com/diamonds-details/16632
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/400225`}>
                    https://showcase.demobw.com/diamonds-details/400225
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/T9321A`}>
                    https://showcase.demobw.com/diamonds-details/T9321A
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/T9376`}>
                    https://showcase.demobw.com/diamonds-details/T9376
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/V21164`}>
                    https://showcase.demobw.com/diamonds-details/V21164
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/education-diamond-buying`}>
                    https://showcase.demobw.com/education-diamond-buying
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/education-gold-buying`}>
                    https://showcase.demobw.com/education-gold-buying
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/education-jewelry-care`}>
                    https://showcase.demobw.com/education-jewelry-care
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/educational-blog`}>
                    https://showcase.demobw.com/educational-blog
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/financing`}>
                    https://showcase.demobw.com/financing
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstone-details/0910-121024`}>
                    https://showcase.demobw.com/gemstone-details/0910-121024
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstone-details/0910-185890`}>
                    https://showcase.demobw.com/gemstone-details/0910-185890
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstone-details/0910-300380`}>
                    https://showcase.demobw.com/gemstone-details/0910-300380
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstone-details/0910-356235`}>
                    https://showcase.demobw.com/gemstone-details/0910-356235
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstone-details/0910-397620`}>
                    https://showcase.demobw.com/gemstone-details/0910-397620
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstone-details/0910-841228`}>
                    https://showcase.demobw.com/gemstone-details/0910-841228
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstone-details/0910-866863`}>
                    https://showcase.demobw.com/gemstone-details/0910-866863
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstone-details/0910-951576`}>
                    https://showcase.demobw.com/gemstone-details/0910-951576
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstone-details/0911-140198`}>
                    https://showcase.demobw.com/gemstone-details/0911-140198
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstone-details/0911-171542`}>
                    https://showcase.demobw.com/gemstone-details/0911-171542
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstone-details/0911-303949`}>
                    https://showcase.demobw.com/gemstone-details/0911-303949
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/indian-jewelry`}>
                    https://showcase.demobw.com/indian-jewelry
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/insurance`}>
                    https://showcase.demobw.com/insurance
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/jewelry/wedding-rings`}>
                    https://showcase.demobw.com/jewelry/wedding-rings
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/military-discount`}>
                    https://showcase.demobw.com/military-discount
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/mission-and-vision`}>
                    https://showcase.demobw.com/mission-and-vision
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/press-media`}>
                    https://showcase.demobw.com/press-media
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/productdetail/14k-rose-freeform-ring-5808122623p`}
                  >
                    https://showcase.demobw.com/productdetail/14k-rose-freeform-ring-5808122623p
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/register`}>
                    https://showcase.demobw.com/register
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/responsible-sourcing`}>
                    https://showcase.demobw.com/responsible-sourcing
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/returns-and-exchanges`}>
                    https://showcase.demobw.com/returns-and-exchanges
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/ringsettingdetail/setting/14k-white-4-mm-round-16-ctw-diamond-semi-set-engagement-ring--12196560010p`}
                  >
                    https://showcase.demobw.com/ringsettingdetail/setting/14k-white-4-mm-round-16-ctw-diamond-semi-set-engagement-ring--12196560010p
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/ringsettingdetail/setting/14k-white-52-mm-round-13-ctw-diamond-semi-set-halo-style-engagement-ring-122467600p`}
                  >
                    https://showcase.demobw.com/ringsettingdetail/setting/14k-white-52-mm-round-13-ctw-diamond-semi-set-halo-style-engagement-ring-122467600p
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/ringsettingdetail/setting/14k-white-55-mm-square-110-ctw-diamond-semi-set-engagement-ring---12197060080p`}
                  >
                    https://showcase.demobw.com/ringsettingdetail/setting/14k-white-55-mm-square-110-ctw-diamond-semi-set-engagement-ring---12197060080p
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/ringsettingdetail/setting/14k-white-55x55-mm-square-13-ctw-diamond-semi-set-engagement-ring--122769600p`}
                  >
                    https://showcase.demobw.com/ringsettingdetail/setting/14k-white-55x55-mm-square-13-ctw-diamond-semi-set-engagement-ring--122769600p
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/ringsettingdetail/setting/14k-white-58-mm-round-13-ctw-diamond-semi-set-engagement-ring-12284260000p`}
                  >
                    https://showcase.demobw.com/ringsettingdetail/setting/14k-white-58-mm-round-13-ctw-diamond-semi-set-engagement-ring-12284260000p
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/ringsettingdetail/setting/14k-white-58-mm-round-18-ctw-diamond-semi-set-engagement-ring---12197960000p`}
                  >
                    https://showcase.demobw.com/ringsettingdetail/setting/14k-white-58-mm-round-18-ctw-diamond-semi-set-engagement-ring---12197960000p
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/ringsettingdetail/setting/14k-white-5x5-mm-square-06-ctw-diamond-semi-set-engagement-ring-12281560000p`}
                  >
                    https://showcase.demobw.com/ringsettingdetail/setting/14k-white-5x5-mm-square-06-ctw-diamond-semi-set-engagement-ring-12281560000p
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/ringsettingdetail/setting/14k-white-65-mm-round-13-ctw-diamond-semi-set-engagement-ring---12196760012p`}
                  >
                    https://showcase.demobw.com/ringsettingdetail/setting/14k-white-65-mm-round-13-ctw-diamond-semi-set-engagement-ring---12196760012p
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/ringsettingdetail/setting/14k-white-6x6-mm-cushion-15-ctw-diamond-semi-set-engagement-ring-12198460001p`}
                  >
                    https://showcase.demobw.com/ringsettingdetail/setting/14k-white-6x6-mm-cushion-15-ctw-diamond-semi-set-engagement-ring-12198460001p
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/ringsettingdetail/setting/14k-white-7x5-mm-emerald-08-ctw-diamond-semi-set-engagement-ring-651582101p`}
                  >
                    https://showcase.demobw.com/ringsettingdetail/setting/14k-white-7x5-mm-emerald-08-ctw-diamond-semi-set-engagement-ring-651582101p
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/ringsettingdetail/setting/14k-white-8x45-mm-marquise-13-ctw-diamond-semi-set-engagement-ring-1220406000p`}
                  >
                    https://showcase.demobw.com/ringsettingdetail/setting/14k-white-8x45-mm-marquise-13-ctw-diamond-semi-set-engagement-ring-1220406000p
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/ringsettingdetail/setting/14k-yellow-65-mm-round-04-ctw-diamond-semi-set-engagement-ring-12279760000p`}
                  >
                    https://showcase.demobw.com/ringsettingdetail/setting/14k-yellow-65-mm-round-04-ctw-diamond-semi-set-engagement-ring-12279760000p
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/ringsettingdetail/setting/14k-yellowwhite-65-mm-round-13-ctw-diamond-semi-set-engagement-ring-651697100p`}
                  >
                    https://showcase.demobw.com/ringsettingdetail/setting/14k-yellowwhite-65-mm-round-13-ctw-diamond-semi-set-engagement-ring-651697100p
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/ringsettingdetail/setting/continuum-sterling-silver-58-mm-round-cubic-zirconia-solitaire-ring-121968108p`}
                  >
                    https://showcase.demobw.com/ringsettingdetail/setting/continuum-sterling-silver-58-mm-round-cubic-zirconia-solitaire-ring-121968108p
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/ringsettingdetail/setting/platinum-65-mm-round-12-ctw-diamond-semi-set-engagement-ring--651721102p`}
                  >
                    https://showcase.demobw.com/ringsettingdetail/setting/platinum-65-mm-round-12-ctw-diamond-semi-set-engagement-ring--651721102p
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/ringsettingdetail/setting/platinum-65-mm-round-15-ctw-diamond-semi-set-engagement-ring-1227006002p`}
                  >
                    https://showcase.demobw.com/ringsettingdetail/setting/platinum-65-mm-round-15-ctw-diamond-semi-set-engagement-ring-1227006002p
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/ringsettings`}>
                    https://showcase.demobw.com/ringsettings
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/ringsettings/style=Vintage`}>
                    https://showcase.demobw.com/ringsettings/style=Vintage
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/sell-your-jewelry`}>
                    https://showcase.demobw.com/sell-your-jewelry
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/services`}>
                    https://showcase.demobw.com/services
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/testimonials`}>
                    https://showcase.demobw.com/testimonials
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/warranty-and-guarantees`}>
                    https://showcase.demobw.com/warranty-and-guarantees
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/watches`}>
                    https://showcase.demobw.com/watches
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/wishlist`}>
                    https://showcase.demobw.com/wishlist
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/`}>https://showcase.demobw.com/</a>
                </li>
                <li>
                  <a href={`${helmet_url}/robots.txt`}>
                    https://showcase.demobw.com/robots.txt
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/sitemap.xml`}>
                    https://showcase.demobw.com/sitemap.xml
                  </a>
                </li>
              </ul>
            </div>
          </Container>
          {/* Whatsapp Chat */}
          {/* <a href="https://wa.me/+16469929024" class="whatsapp_float" target="_blank" rel="noopener noreferrer">
        <Image src={whatsapp} alt="whatspp chat"></Image>
      </a> */}
          {/* Whatsapp Chat */}
          {/* <div className='rcs_footer_chat'>
        <div className='rcs_diamond_specialist'>

        </div>
        <div className='rcs_diamond_tdo_chat'>

        </div>
      </div> */}
        </div>
     
    </div>
  );
};
export default Footer;
